import React, { useState } from 'react';
import ExchangeParentSection from '../components/ExchangeParentSection';
// import RTUpbitCollectorChart from '../features/RTUpbitCollectorChart'; // 일시 비활성: 실시간 차트 + 종목 현황(가격 순)
import BinanceAlertShortLivePanel from '../features/binance/BinanceAlertShortLivePanel';
import BithumbSpotPaperPanel from '../features/bithumb/BithumbSpotPaperPanel';
import IbkrDashboardPanel from '../features/ibkr/IbkrDashboardPanel';
import IbkrTfsaPaperPanel from '../features/ibkr/IbkrTfsaPaperPanel';
import KiwoomDayTradingPaperPanel from '../features/kiwoom/KiwoomDayTradingPaperPanel';
import KiwoomPairsPaperPanel from '../features/kiwoom/KiwoomPairsPaperPanel';
import { DashboardLocaleProvider, useDashboardT } from '../features/shared/dashboardLocale';
import type { DashboardLocale } from '../features/shared/dashboardMessages';
// import KiwoomStreamDashboard from '../features/kiwoom/KiwoomStreamDashboard'; // Old Kiwoom — 화면에서 숨김
// import { binanceH3, upbitH3 } from '../features/kiwoom/kiwoomTheme'; // 일시 비활성 (실시간 Binance/Upbit 차트)
import { useIsMobile } from '../hooks/useMediaQuery';

// Upbit / New Upbit 탭 제거 (2026-07-24): universe pipeline과 multi-paper fleet 전략이
// 전부 종료돼 두 패널 모두 죽은 analyser 엔드포인트를 폴링하고 있었다. 업비트 알림에서
// 출발하는 라인은 살아 있지만 그건 Binance 탭이 보여준다.
//
// 2026-07-25: 기존 스트림/파이프라인 대시보드는 Old Kiwoom으로 내리고,
// KRX pairs paper + day trading paper를 Kiwoom 섹션 2열로 broker row에 배치.
// Old Kiwoom 섹션은 코멘트아웃해 화면에서 숨김 (코드는 유지).
//
// 2026-10-19: Binance ↔ IBKR 사이에 Bithumb 섹션 (midnight ride paper, 92% 주간 검증).
type DashboardTab = 'binance' | 'bithumb' | 'ibkr' | 'kiwoom'; // | 'old-kiwoom'

const KiwoomPageContent: React.FC = () => {
  const isMobile = useIsMobile();
  const t = useDashboardT();
  const [mobileTab, setMobileTab] = useState<DashboardTab>('binance');

  const sectionClass = isMobile ? 'exchange-section-mobile' : undefined;
  const showBinance = !isMobile || mobileTab === 'binance';
  const showBithumb = !isMobile || mobileTab === 'bithumb';
  const showIbkr = !isMobile || mobileTab === 'ibkr';
  const showKiwoom = !isMobile || mobileTab === 'kiwoom';

  return (
    <div className="App">
      <main
        className="app-main app-main--dashboard"
        style={{ backgroundColor: '#0d1117', minHeight: '100vh', padding: '20px', maxWidth: '100%', minWidth: 0, overflowX: 'clip' }}
      >
        {isMobile && (
          <div className="dashboard-top-bar">
            <div className="dashboard-mobile-tabs" role="tablist" aria-label={t('dashboard.mobileTabs.ariaLabel')}>
            <button
              type="button"
              role="tab"
              aria-selected={mobileTab === 'binance'}
              className={`dashboard-mobile-tab dashboard-mobile-tab--binance${mobileTab === 'binance' ? ' dashboard-mobile-tab--active' : ''}`}
              onClick={() => setMobileTab('binance')}
            >
              Binance
            </button>
            <button
              type="button"
              role="tab"
              aria-selected={mobileTab === 'bithumb'}
              className={`dashboard-mobile-tab dashboard-mobile-tab--bithumb${mobileTab === 'bithumb' ? ' dashboard-mobile-tab--active' : ''}`}
              onClick={() => setMobileTab('bithumb')}
            >
              Bithumb
            </button>
            <button
              type="button"
              role="tab"
              aria-selected={mobileTab === 'ibkr'}
              className={`dashboard-mobile-tab dashboard-mobile-tab--ibkr${mobileTab === 'ibkr' ? ' dashboard-mobile-tab--active' : ''}`}
              onClick={() => setMobileTab('ibkr')}
            >
              IBKR
            </button>
            <button
              type="button"
              role="tab"
              aria-selected={mobileTab === 'kiwoom'}
              className={`dashboard-mobile-tab dashboard-mobile-tab--kiwoom${mobileTab === 'kiwoom' ? ' dashboard-mobile-tab--active' : ''}`}
              onClick={() => setMobileTab('kiwoom')}
            >
              Kiwoom
            </button>
            </div>
          </div>
        )}

        <div className="dashboard-broker-row">
          {showBinance && (
            <ExchangeParentSection title="Binance" theme="binance" storageKey="exchange-section-binance" className={sectionClass}>
              <BinanceAlertShortLivePanel />
            </ExchangeParentSection>
          )}

          {showBithumb && (
            <ExchangeParentSection title="Bithumb" theme="bithumb" storageKey="exchange-section-bithumb" className={sectionClass}>
              <BithumbSpotPaperPanel />
            </ExchangeParentSection>
          )}

          {showIbkr && (
            <ExchangeParentSection title="IBKR" theme="ibkr" storageKey="exchange-section-ibkr" className={sectionClass}>
              <div className="ibkr-panels-row">
                <IbkrDashboardPanel />
                <IbkrTfsaPaperPanel />
              </div>
            </ExchangeParentSection>
          )}

          {showKiwoom && (
            <ExchangeParentSection title="Kiwoom" theme="kiwoom" storageKey="exchange-section-kiwoom" className={sectionClass}>
              <div className="kiwoom-panels-row">
                <KiwoomPairsPaperPanel />
                <KiwoomDayTradingPaperPanel />
              </div>
            </ExchangeParentSection>
          )}
        </div>

        {/* {showOldKiwoom && (
          <ExchangeParentSection title="Old Kiwoom" theme="kiwoom" storageKey="exchange-section-kiwoom-stream" className={sectionClass}>
            <KiwoomStreamDashboard />
          </ExchangeParentSection>
        )} */}

      </main>
    </div>
  );
};

const KiwoomPage: React.FC<{ locale: DashboardLocale }> = ({ locale }) => (
  <DashboardLocaleProvider locale={locale}>
    <KiwoomPageContent />
  </DashboardLocaleProvider>
);

export default KiwoomPage;
